/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Validation_Subjectrequired3Inputs */

const en_coinvestments_editemail_validation_subjectrequired3 = /** @type {(inputs: Coinvestments_Editemail_Validation_Subjectrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email subject is required`)
};

/**
* | output |
* | --- |
* | "Email subject is required" |
*
* @param {Coinvestments_Editemail_Validation_Subjectrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_validation_subjectrequired3 = /** @type {((inputs?: Coinvestments_Editemail_Validation_Subjectrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Validation_Subjectrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_validation_subjectrequired3(inputs)
});
export { coinvestments_editemail_validation_subjectrequired3 as "coInvestments_editEmail_validation_subjectRequired" }